export const KPI_REPORTING_FILTERS = {
    SITE_NAMES_ASR: ['Site 1',
        'Site 2',
        'Site 4',
        'Site 5',
        'Site 6',],
    SITE_NAMES_JV: [
        'Site 3',
        'Site 7'],
    OPERATING_ASSETS: ['Onshore', 'Offshore'],
    BUSINESS_ENTITIES: ['Subsidiaries', 'Joint Ventures'],
}